// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption">
        &copy; Todos los derechos reservados{' '}
        <Link href="https://sistemappcompany.com/" target="_blank" underline="hover">
          SistemApp Company - 2025
        </Link>
      </Typography>
      
    </Stack>
  );
}
